/*
 * Script général, applicable à toutes les pages du site.
 */
import Menu from './modules/menu';
const menu = new Menu();
